<template>
  <chart-container
    class="bg-gradient-blue"
    :titleChart="titleChart"
    @onCSVDownload="downloadCsvMaps(titleChart)"
    @zoomEnabled="zoomEnabled"
    @zoomDisabled="zoomDisabled"
    :zoomGraphValue="zoomGraphValue"
    :isZoomEnabled="this.showdata == rawData && !(countryList == 0) && !(newSitesSelected == 0) && !(participantsSelected == 0) && !(this.conversioninvalid == 0)"
    :downloadId="downloadId"
    :specificSiteId="specificSiteId"
    :downloadShow="this.showdata == rawData && !(countryList == 0) && !(newSitesSelected == 0) && !(participantsSelected == 0) && !(this.conversioninvalid == 0)"
    titleTooltip="This chart includes a map that displays the number of participants and their current compliance score, which includes all tasks, surveys, ePROs, as well as participant and site telehealth by geographic region. The calculations used here differ slightly from Study Activity Compliance by Day, as site team task completion is not included in this calculation, and unscheduled activities like eConsent or Learn tasks are omitted as well.<br>Each site is represented as a single bubble, with the bubble size based on the number of participants at that site. The opacity level represents compliance rates, with the darker bubbles showing higher compliance. Highly compliant sites with a lot of participants will have the biggest, darkest bubbles. Active sites without active participants within the date filter window will not be displayed."
    :tooltipHtmlContent="true"
  >
    <div class="col-xl-12 mb-0 pb-0 pl-0" slot="body">
      <div class="map-flex" v-if="this.showdata == rawData && !(countryList == 0) && !(newSitesSelected == 0) && !(participantsSelected == 0) && conversioninvalid" style="margin-right: -42px">
        <div class="card-participant-map">
          <compliance_status_google_map :participantsSelected="participantsSelected" :rawData="rawData" :zoomValue="this.zoomValue" :countrySelected="countrySelected" :sitesSelected="sitesSelected" :countryList="countryList" :allSiteList="allSiteList" />
        </div>
        <div class="card-map-legend">
          <ul class="pl-20" :class="specificSiteId.length === 0 ? 'non-rbac' : 'rbac-legend'">
            <li>
              <span> Number of Participants </span>
            </li>
            <li class="tagli" style="padding-bottom: 1px">
              <span class="normal"></span>
              <span class="normal17"></span>
              <span class="normal14"></span>
              <span class="normal11"></span>
              <span class="normal9"></span>
            </li>
          </ul>
          <ul class="pl-20">
            <li style="margin-bottom: -3px; margin-top: -3px"><span> Compliance </span> <br /></li>
            <li>
              <span>
                <span class="zeroto20" style="bottom: auto; margin-top: -3px"></span>
                0% - 20%
              </span>
            </li>
            <li>
              <span>
                <span class="twentyto40" style="bottom: auto; margin-top: -3px"></span>
                >20% - 40%
              </span>
            </li>
            <li>
              <span>
                <span class="fourtyto60" style="bottom: auto; margin-top: -3px"></span>
                >40% - 60%
              </span>
            </li>
            <li>
              <span>
                <span class="sixteyto80" style="bottom: auto; margin-top: -3px"></span>
                >60% - 80%
              </span>
            </li>
            <li>
              <span>
                <span class="eightey" style="bottom: auto; margin-top: -3px"></span>
                >80%
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="align-center p-60" slot="body">
        <div class="card-text-title no-data" v-if="true">No Data In</div>
      </div>
      <div class="remove-elem-download text-left min-height-0 pl-0 pb-0" style="bottom: auto; margin-top: 10px" v-if="this.showdata == rawData && !(countryList == 0) && !(newSitesSelected == 0) && !(participantsSelected == 0) && !(this.conversioninvalid == 0)">
        <img v-on:click="onZoomOut" src="/static/img/icon-zoomout.svg" width="25" aria-haspopup="true" aria-expanded="false" title="Zoom Out" style="cursor: pointer" />
        <img v-on:click="onZoomIn" src="/static/img/icon-zoomin.svg" width="25" aria-haspopup="true" aria-expanded="false" title="Zoom In" style="cursor: pointer" />
      </div>
    </div>
  </chart-container>
</template>

<script>
import compliance_status_google_map from "../maps/compliance_status_google_map";
import ChartContainer from "./chart-container-dark-blue-map";
import { mapSettings } from "../maps/config";
import { downloadCSV } from "../../services/visualization/data-management";

export default {
  components: {
    compliance_status_google_map,
    ChartContainer
  },
  props: {
    participantsSelected: [Array, String],
    titleChart: [String],
    rawDataCSV: { default: null },
    checkingstatusofdata: { default: null },
    rawData: { default: null },
    specificSiteId: { type: Array, default: () => {} },
    sitesSelected: [Array, String],
    countrySelected: [Array, String],
    countryList: { type: Array, default: () => [] },
    allSiteList: { type: Array, default: () => [] },
    dataLoaded: { type: Boolean, default: false },
    zoomGraphValue: { type: String, default: "" },
    mapdata: { default: null },
    conversioninvalid: { type: Array, default: () => [] },
  },
  data() {
    return {
      Countrysite: false,
      downloadId: "complianceMaps",
      newCountrySelected: this.countrySelected,
      newSitesSelected: this.sitesSelected,
      zoomValue: 4,
      showdata: []
    };
  },
  mounted() {},
  methods: {
    Checking(rawData) {
      if (!(this.conversioninvalid == 0)) {
        this.conversioninvalid.splice(0, this.conversioninvalid.length);
      }
      if (this.Countrysite) {
        for (let j in rawData) {
          for (const p in rawData[j]) {
            const siteanme = p;
            const alldata = rawData[j][p];
            const temp = {
              siteanme: siteanme,
              ...alldata
            };
            this.conversioninvalid.push(temp);
          }
        }
      } else {
        const countrySelected = this.countrySelected == "all" ? this.countryList : this.countrySelected;
        const siteSelected = this.sitesSelected == "all" ? this.allSiteList : this.sitesSelected;
        const countryfilter = countrySelected;
        const stateselected = siteSelected;
        for (const k in countryfilter) {
          for (const i in rawData) {
            if (countryfilter[k] == i) {
              for (const l in stateselected) {
                for (let j in rawData[i]) {
                  if (stateselected[l] == j) {
                    const siteanme = j;
                    const alldata = rawData[i][j];
                    const temp = {
                      siteanme: siteanme,
                      ...alldata
                    };
                    this.conversioninvalid.push(temp);
                  }
                }
              }
            }
          }
        }
      }
      if (this.conversioninvalid == 0) {
      }
    },
    downloadCsvMaps(title) {
      let csvHeaders;

      const csvContent = [];
      csvHeaders = ["Site Name", "City", "State/Province", "Country", "Compliance Rate %", "Total Participants"];
      this.conversioninvalid.map(item => csvContent.push([item.siteanme, item.city, item.state, item.country, item.complianceRate, item.nParticipant]));
      downloadCSV(title, csvHeaders, csvContent, this.specificSiteId);
    },
    onClick: function(value) {
      const index = this.newStatusSelected.indexOf(value);

      if (index > -1) {
        this.newStatusSelected.splice(index, 1);
      } else {
        this.newStatusSelected.push(value);
      }
    },
    onZoomIn: function() {
      if (this.zoomValue < 6) {
        if (this.zoomValue >= 0 && this.zoomValue < 19) {
          this.zoomValue += 1;
        }
      }
    },
    onZoomOut: function() {
      if (!(this.zoomValue < 2)) {
        if (this.zoomValue > 0 && this.zoomValue <= 19) {
          this.zoomValue -= 1;
        }
      }
    },
    zoomEnabled() {
      this.$emit("zoomEnabled");
    },
    zoomDisabled() {
      this.$emit("zoomDisabled");
    }
  },
  watch: {
    rawDataCSV: function(value) {
      this.Checking(value);
    },
    participantsSelected: function() {
      this.Countrysite = true;
    },
    checkingstatusofdata: function(data) {
      this.showdata = data.body.data;
    },
    allSiteList: function(value) {
      this.newStatusSelected = value;
    },
    statusSelected: function(value) {
      this.newStatusSelected = value;
    },
    zoomValue: function(value) {
      this.zoomValue = value;
    },
    countrySelected: function(newValue) {
      this.newCountrySelected = newValue;
    },
    sitesSelected: function(newValue) {
      this.Countrysite = false;
      this.newSitesSelected = newValue;
      this.Checking(this.rawDataCSV);
    }
  },
  computed: {
    config() {
      return {
        ...mapSettings,
        zoomControl: false,
        center: { lat: 0, lng: 0 }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.study-participant-status-maps-zoom .card-participant-map {
  height: 450px;
}

img {
  margin-right: 9px;
}

.tagli {
  width: 100px;
  display: flex;
  justify-content: end;
  align-items: end;
}

.card-participant-map {
  width: calc(100% - 155px);
  height: 250px;
  margin-top: 10px;
}

.map-flex {
  display: flex;
  align-items: center;
}

.card-map-legend {
  .rbac-legend {
    font-size: 12px;
    padding-left: 25px;
  }

  span {
    color: #d9d9d9;
  }

  .selected {
    text-decoration: line-through;
    font-style: italic;
    opacity: 0.5;
  }

  ul li {
    list-style-type: none;
    cursor: pointer;
    padding-bottom: 5px;
    display: flex;
    margin-bottom: 9px;

    span {
      font-size: 10px;
      line-height: 1;

      span {
        height: 10px;
        width: 10px;
        float: left;
        margin-right: 8px;
      }
    }

    .normal {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fdbf6f;
      margin-right: 0.4rem;
    }

    .normal17 {
      width: 17px;
      height: 17px;
      border-radius: 50%;
      background-color: #fdbf6f;
      margin-right: 0.4rem;
    }

    .normal14 {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: #fdbf6f;
      margin-right: 0.4rem;
    }

    .normal11 {
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background-color: #fdbf6f;
      margin-right: 0.4rem;
    }

    .normal9 {
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background-color: #fdbf6f;
      margin-right: 0.4rem;
    }

    .zeroto20 {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fff2e2;
    }

    .twentyto40 {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fee5c5;
    }

    .fourtyto60 {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fed9a9;
    }

    .sixteyto80 {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fecc8c;
    }

    .eightey {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fdbf6f;
    }
  }

  .backgroundcolour {
    background-color: red;
    /* For browsers that do not support gradients */
    // background-image: linear-gradient(#c5d1d6, #243e64);
  }

  .bg-gradient-blue {
    .fusioncharts-container > svg {
      background-color: unset !important;
    }
  }
}
</style>
